module.exports = "<dashboard-checkbox-input></dashboard-checkbox-input>"